import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

function ActionFormatter({ title, icon, className, disabled, ...props }) {
  return (
    <div className="actionFormatter">
      {disabled ? (
        <IconButton className={className} disabled={disabled} {...props}>
          {icon}
        </IconButton>
      ) : (
        <Tooltip title={title} placement="bottom">
          <IconButton className={className} disabled={disabled} {...props}>
            {icon}
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
}

export default ActionFormatter;
